<template lang="pug">
.ref-pub-info-wrapper(v-if="refPubInfo")
  .ref-pub-info(:style="refPubInfoStyle", ref="refPubInfo")
    .title(@mousedown="downTitle") {{ refPubInfo.n }}
      .close(@click="engageReportCardShown = false") &times;
    .bg(:style="{ 'background-image': `url('${ refPubInfo.i }'` }")
    .industry {{ refPubInfo.industry }}
    a.watchlist-link(:href="watchlistUrl", target="_blank") spectrum
    .row
      .ticker {{ refPubInfo.s && refPubInfo.s[0] || '' }}
      .performance(v-if="refPubInfo.performance") {{ (refPubInfo.performance || {}).label }}
        .arrow(:class="{ [(refPubInfo.performance || {}).label]: true }") &#10142;
          .bar
      .no-performance(v-else) &nbsp;
    .theme(v-if="refPubInfo.theme") {{ (refPubInfo.theme.t || refPubInfo.theme.n || '').replace(/ themes/i, '') }}
      .close(@click="watchlistThemesParentFilter = null") &times;
    .charts(v-if="refPubInfo.theme")
      .chart.horse
        .bar(v-for="pub in refPubInfo.theme.ps.sort((a, b) => b.cpr - a.cpr)",
             @click="watchlistThemesRefPub = pub.key",
             :class="{ selected: pub.key === refPubInfo.key }",
             :style="{ width: `${ pub.cpr }%` }")
          .title {{ pub.n }}
          //.toggle-robo(@click.stop.capture="toggleSelectedWatchlistPublisher(pub.key)",
          //             :class="{ on: publisherSelected(pub.key) }")
          //  .bars
          //    .bar.tall.gap
          //    .bar
          //    .bar
          //    .bar.tall
          //    .bar.gap
          //    .bar.tall
          //    .bar
          //    .bar.tall
          //    .bar.tall
          //  .eyes
          //    .eye
          //    .eye
      .ariel-view
        //.line(v-for="theme in childThemes.filter(({ cr }) => cr >= 50).sort((a, b) => b.cr - a.cr).filter((item, index) => index < 57)",
        .labels
          .label(v-for="(rating, index) in ['very poorly', 'poorly', 'well', 'very well']",
                 @click="setSentiment(rating, true)",
                 @mouseenter="watchlistThemesHoverRefPubSentiment = rating",
                 @mouseleave="watchlistThemesHoverRefPubSentiment = null",
                 :class="{ on: rating === $store.state.watchlistThemesRefPubSentiment }",
                 :rating="rating")
            //- todo: add an orange dot to the rating that is watchlistThemesRefPubSentiment
        .lines
          .line(v-for="theme in arielViewThemes",
                :class="{ on: selectedWatchlistThemes[theme.n] }",
                NOTclick="toggleSelectedWatchlistTheme(theme.n)"
                :title="theme.t || theme.n")
            .bar(:style="{ width: `${ theme.cr - 50 }%` }", :title="theme.t || theme.n")
              .label {{ theme.t || theme.n }}
            .performance
              .cell(v-for="(rating, index) in ['very poorly', 'poorly', 'well', 'very well']",
                    :title="percentToPerf(theme.ps, index) && rating || ''",
                    :rating="rating",
                    :class="{ on: percentToPerf(theme.ps, index) }")
          .pager(v-if="(importantChildThemes || []).length > itemsPerPage")
            .previous(@click="arielOffset -= itemsPerPage", :style="{ visibility: arielOffset && 'visible' || 'hidden' }") previous
            .next(@click="arielOffset += itemsPerPage", :style="{ visibility: (arielViewThemes || []).length === itemsPerPage  && 'visible' || 'hidden' }") next
    .themes(v-else)
      .theme(v-for="theme in filteredThemes.filter(({ cth }) => cth)", @click="watchlistThemesParentFilter = theme.n") {{ (theme.t || theme.n || '').replace(/ themes/i, '') }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
let loadTimer;
let pubSwitcherTimer;
let tooltipTimer;
export default {
  name: 'reportCard',
  data() {
    return {
      mouseX: 0,
      mouseY: 0,
      offsetLeft: 0,
      offsetRight: 0,
      hoverImportance: '',
      hoverPerformance: '',
      showLegend: false,
      titleMoving: false,
      titleX: 0,
      titleY: 0,
      arielOffset: 0
    };
  },
  watch: {
    importantChildThemes() {
      this.arielOffset = 0;
    },
    selectedWatchlistThemes() {
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => this.loadRoboReport('custom'), 700);
    }
  },
  computed: {
    ...mapGetters([
      'themes',
      'selectedWatchlistThemes',
      'analytics',
      'topParentThemes',
      'watchlistShown',
      'watchlistThemesShown',
      'watchlistThemesForPickerMax',
      'filteredWatchlistThemes',
      'roboReportShown',
      'publishers',
      'watchlistPublishers',
      'refPubInfo',
      'engageBap',
      'engage'
    ]),
    ...vuexComputed(
      'selectedWatchlistPublishers',
      'watchlistThemesParentFilter',
      'watchlistThemesRefPub',
      'watchlistThemesRefPubSentiment',
      'watchlistThemesHoverRefPubSentiment',
      'watchlistThemesRefPubSwitcher',
      'watchlistThemesRefPubSwitcherFilter',
      'watchlistThemesRefPubSort',
      'watchlistThemesAndOr',
      'refPubInfoShown',
      'refPubInfoNudge',
      'engageReportCardShown'
    ),
    watchlistUrl() {
      const { engage = {}, refPubInfo = {} } = this;
      const { scenes = {} } = engage;
      const { reportCards = [] } = scenes[refPubInfo.key] || {};
      const [rc = {}] = reportCards || [];
      console.log('watchlistUrl', reportCards, rc.watchList, refPubInfo.n);
      // const { reportCard: rc, n } = engageBap;
      return rc && `/?wl=${ rc.watchList };rc=${ refPubInfo.n }`;
      // const { engageBap = {} } = this;
      // const { reportCard: rc, n } = engageBap;
      // return rc && `/?wl=${ rc.watchList };rc=${ n }`;
    },
    childThemes() {
      const { filteredThemes, watchlistThemesParentFilter: wtpf, themes } = this;
      let r = [];
      // console.log('childThemes', wtpf);
      if (wtpf && filteredThemes) {
        // console.log('childThemes', wtpf, filteredThemes);
        //const parentThemes = filteredThemes?.filter(({ cth }) => cth);
        // if (parentThemes.length === 1) {
        if (themes && wtpf && themes[wtpf]) {
          const filteredMap = filteredThemes.reduce((map, { n }) => {
            map[n] = true;
            return map;
          }, {});
          // console.log('childThemes', wtpf, parentThemes[0].cth, filteredMap);
          // console.log('childThemes', wtpf, themes[wtpf].cth, filteredMap);
          //r = parentThemes[0].cth
          r = themes[wtpf].cth
            .filter(({ n }) => filteredMap[n])
            .map(({ n, cr }) => {
              return { ...themes[n], cr };
            });
        }
      }
      // console.log('childThemes:', r);
      return r;
    },
    itemsPerPage() {
      const max = 42;
      return ((this.importantChildThemes || []).length === max && max) || max - 1;
    },
    importantChildThemes() {
      const { childThemes, watchlistThemesParentFilter: filter, themes } = this;

      const r = childThemes.filter(({ cr }) => cr >= 50).sort((a, b) => b.cr - a.cr);
      // console.log('crs', childThemes, r.map(({ cr }) => cr));
      // const r = childThemes.filter(th => dynamicCr(th) >= 50).sort((a, b) => dynamicCr(b) - dynamicCr(a));
      // console.log('ict', childThemes, /*themes[filter].cth,*/ childThemes[3].n, childThemes[3] && dynamicCr(childThemes[3]), r);
      return r;
      //return childThemes.filter(th => dynamicCr(th) >= 50).sort((a, b) => dynamicCr(b) - dynamicCr(a));
      function dynamicCr(theme) {
        let r = theme.cr;
        //console.log('dynamicCr', themes);
        if (filter && themes) {
          if (theme.cth) {
            r = 100;
          } else {
            //const { cth } = themes[filter] || {};
            if (theme.index > -1) {
              r = childThemes[theme.index]?.cr || r;
              // r = cth[theme.index]?.cr || r;
            }
            // const { cth } = themes[filter] || {};
            // if (cth && theme.index > -1) {
            //   r = cth.find(({ n }) => n === theme.n)?.cr || r;
            //   // r = cth[theme.index]?.cr || r;
            // }
          }
        }
        return r;
      }
    },
    arielViewThemes() {
      const {
        importantChildThemes: ict,
        arielOffset,
        itemsPerPage,
        watchlistThemesRefPubSentiment: sentiment,
        watchlistThemesHoverRefPubSentiment: hoverSentiment,
        refPub,
        morphedPS
      } = this;
      let r = ict;
      const s = hoverSentiment || sentiment;
      if (s) {
        const cprToRating = cpr => {
          /*let logValue =
            (cpr <= 25 && 'very poorly') ||
            (cpr <= 50 && 'poorly') ||
            (cpr >= 75 && 'very well') ||
            (cpr >= 50 && 'well');
          console.log('cprToRating', cpr, logValue);*/
          return (
            (cpr <= 25 && 'very poorly') ||
            (cpr <= 50 && 'poorly') ||
            (cpr >= 75 && 'very well') ||
            (cpr >= 50 && 'well')
          );
        };
        // const was = [...r];
        r = r.filter(({ ps }) => {
          // console.log('avt filtering', morphedPS(ps), morphedPS(ps).find(({ n }) => n === refPub.n), refPub);
          return cprToRating(morphedPS(ps).find(({ n }) => n === (refPub?.n || '-1'))?.cpr) === s;
        });
        //r = r.filter(({ ps }) => cprToRating(morphedPS(ps)[refPub.n].cpr) === s);
        // console.log('avt', refPub, cprToRating(55), s, was, r);
      }
      return r.filter((item, index) => arielOffset <= index && index < arielOffset + itemsPerPage);
    },
    refPub() {
      const { watchlistThemesRefPub, publishers, watchlistPublishers: wps } = this;
      return publishers[watchlistThemesRefPub] || { id: watchlistThemesRefPub, n: wps[watchlistThemesRefPub].n };
    },
    refPubInfoStyle() {
      const { refPubInfoNudge: { top, left } } = this;
      return { transform: `translate3d(${ left }px, ${ top }px, 0)` };
    },
    sentiment() {
      return this.watchlistThemesRefPubSentiment;
    },
    filteredThemes() {
      const { filteredWatchlistThemes, morphedPS, sentiment, watchlistThemesRefPub: refPub } = this;
      //console.log('filteredWatchlistThemes', filteredWatchlistThemes);
      // console.log(
      //   'ftt',
      //   (sentiment &&
      //     refPub &&
      //     filteredWatchlistThemes.filter(({ ps, n }) => show(morphedPS(ps).find(({ key }) => key === refPub), n))) ||
      //     filteredWatchlistThemes
      // );
      return (
        (sentiment &&
          refPub &&
          filteredWatchlistThemes.filter(({ ps, n }) => show(morphedPS(ps).find(({ key }) => key === refPub), n))) ||
        filteredWatchlistThemes
      );
      function show(ps, n) {
        const { cpr = 0 } = ps || {};
        //console.log('show ps', ps, cpr, sentiment, refPub, n);
        // console.log('show ps', cpr);
        return (
          ps &&
          {
            'very poorly'() {
              return cpr <= 25;
            },
            poorly() {
              // return cpr <= 50;
              return 25 < cpr && cpr <= 50;
            },
            well() {
              return 50 < cpr && cpr < 75;
            },
            'very well'() {
              return cpr >= 75;
            }
          }[sentiment]()
        );
      }
    },
    parentThemes() {
      const { topParentThemes, themes } = this;
      // console.log('computed themes', topParentThemes, (selectedVis === 'selectedThemes' && Object.keys(selectedThemes) || topParentThemes)
      //   .filter(n => themes[n])
      //   .map(n => themes[n]));
      return topParentThemes.map(([n]) => n)
        .filter(n => themes[n])
        .map(n => themes[n]);
    },
    sortedFilteredRefPubs() {
      const { filteredRefPubs, watchlistThemesRefPubSort: sort, filteredThemes: themes, morphedPS, watchlistThemesParentFilter: parentTheme } = this;
      let r = Object.entries(filteredRefPubs).map(([key, value]) => ({ key, ...value }));
      if (sort) {
        const t = themes.map(({ ps }) => morphedPS(ps));
        if (parentTheme) {
          const { ps } = themes.find(({ n }) => n === parentTheme) || {};
          // console.log('parent theme', parentTheme);
          const mps = morphedPS(ps);
          // console.log('morphed', mps);
          r.forEach(pub => {
            pub.sortWeight = (mps.find(({ key }) => key === pub.key) || { cr: 0 }).cr;
          });
        } else {
          const tally = t.reduce((tally, ps) => {
            ps.forEach(({ key, cr }) => {
              tally[key] = tally[key] || 0;
              tally[key] += cr;
            });
            return tally;
          }, {});
          r.forEach(pub => {
            pub.sortWeight = tally[pub.key];
          });
        }
        r.sort((a, b) => {
          let r = a.sortWeight - b.sortWeight;
          return (sort === 'ascending' && r) || b.sortWeight - a.sortWeight;
        });
      }
      // console.log('sortedFilteredRefPubs', r);
      return r;
    },
    filteredRefPubs() {
      const { publishers, watchlistThemesRefPubSwitcherFilter } = this;
      return Object.entries(publishers)
        .filter(([_, { n, s }]) => testPub(n, s))
        .reduce((map, [key, pub]) => {
          map[key] = pub;
          return map;
        }, {});
      function testPub(n, s) {
        const searchText = `${ n }|${ (s || []).join('|') }`;
        return !watchlistThemesRefPubSwitcherFilter || watchlistThemesRefPubSwitcherFilter.split(/\s+/).every(testWord);
        function testWord(word) {
          const tester = new RegExp(escapeRegExp(word), 'i');
          return tester.test(searchText);
        }
      }
      function escapeRegExpAndBound(s) {
        return `\\b${ escapeRegExp(s) }\\b`; // $& means the whole matched string
      }
      function escapeRegExp(s) {
        return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
      }
    }
  },
  methods: {
    ...mapActions(['toggleSelectedWatchlistTheme', 'toggleSelectedWatchlistPublisher', 'loadRoboReport']),
    percentToPerf(ps, index) {
      const { morphedPS, refPubInfo } = this;
      const value = morphedPS(ps).find(({ key }) => key === refPubInfo.key).cpr;
      return [
        value => value <= 25,
        value => 25 < value && value <= 50,
        value => 50 < value && value < 75,
        value => value >= 75
      ][index](value);
      // const min = index * 25;
      // const max = min + 25;
      // return min < value && value < max;
      // return min < value && value <= max;
    },
    publisherSelected(publisher) {
      const { selectedWatchlistPublishers } = this;
      const length = Object.keys(selectedWatchlistPublishers).length;
      return !length || selectedWatchlistPublishers[publisher];
    },
    downTitle(e) {
      const { $refs: { refPubInfo }, refPubInfoNudge: { top, left }, $el } = this;
      const { clientX, clientY } = e;
      const nudge = (left, top) => (this.refPubInfoNudge = { left, top });
      //style.transform = `translate3d(1px, 1px, 0)`;
      const handlers = {
        move(e) {
          console.log('move', left + clientX - e.clientX);
          nudge(left + e.clientX - clientX, top + e.clientY - clientY);
        },
        up() {
          console.log('up1', $el || 'huh?');
          $el.removeEventListener('mousemove', handlers.move);
          $el.removeEventListener('mouseup', handlers.up);
          console.log('up2');
        }
      };
      $el.addEventListener('mousemove', handlers.move);
      $el.addEventListener('mouseup', handlers.up);
    },
    setSentiment(value, toggle) {
      const { $store: { state: { watchlistThemesRefPubSentiment: wtrps } } } = this;
      // console.log('setSentiment', value, toggle, wtrps !== value, (!toggle || wtrps !== value) && value || null);
      this.watchlistThemesRefPubSentiment = (!toggle || wtrps !== value) && value || null;
    },
    morphedPS(ps) {
      //const pt = this.analytics.thd.pt;
      const { analytics: { thd: { pt } }, publishers, watchlistPublishers: wps } = this;
      //console.log('morphedPS index', Object.entries(ps));
      return Object.entries(ps || {})
        .reduce((all, [i, v]) => {
          const key = pt[i];
          all.push({ ...(publishers[key] || (wps[key] && { id: key, n: wps[key].n }) || {}), key, ...(v || {}) });
          return all;
        }, [])
        .sort((a, b) => a.cr - b.cr);
    },
    weight(c) {
      return (c / this.watchlistThemesForPickerMax).toPrecision(2);
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.ref-pub-info-wrapper {
  pointer-events: none;
  position: fixed;
  right: 4rem;
  top: 6rem;
  transform: translate3d(-150vw, 0, 0);
  transition: transform 600ms ease-in-out;
  z-index: 17000;
  &.shown {
    transform: translate3d(0, 0, 0);
  }
  .ref-pub-info {
    cursor: default;
    pointer-events: all;
    user-select: none;
    min-width: 42vw;
    min-height: 40rem;
    background-color: white;
    border: 4px solid orange;
    box-shadow: 1px 1px 3px orange;
    box-sizing: border-box;
    border-radius: 0.5rem;
    padding: 4.9rem 4rem 0.5rem 10rem;
    text-align: left;
    overflow: hidden;
    color: $brn;
    & > .title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      //transform: translate3d(-50%, 0, 0);
      font-size: 4rem;
      text-align: center;
      background-color: orange;
      color: white;
      text-shadow: 0 0 2px black;
      font-weight: 700;
      font-family: Assistant, Roboto, sans-serif;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: 2rem solid orange;
      box-sizing: border-box;
      & > .close {
        position: absolute;
        top: -0.5rem;
        right: 0.25rem;
        transform-origin: top right;
        transform: scale(0.5);
      }
    }
    & > .bg {
      background: white center no-repeat;
      background-size: contain;
      position: absolute;
      top: 4.5rem;
      left: 0.5rem;
      width: 8rem;
      height: 8rem;
      border-radius: 0.5rem;
      //border-top-left-radius: 0.5rem;
      //border-bottom-left-radius: 0.5rem;
    }
    & > .industry {
      position: absolute;
      bottom: 0.5rem;
      left: 0.5rem;
    }
    & > .theme {
      position: relative;
      left: -1rem;
      margin-top: 1rem;
      margin-right: 14.5rem;
      font-size: 2.5rem;
      white-space: nowrap;
      max-width: 29rem;
      //width: rem;
      z-index: 2;
      & > .close {
        position: absolute;
        top: -1rem;
        right: -19.25rem;
        transform: scale(0.6);
        color: #ccc;
        &:hover {
          color: black;
        }
      }
    }
    & > .watchlist-link {
      position: absolute;
      top: 2rem;
      right: 0.5rem;
      color: white;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 0.8rem;
    }
    & > .row {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 0.5rem;
      z-index: 1;
      & > .ticker {
        color: white;
        z-index: 1;
        font-weight: 700;
        transform: translate3d(0, 1px, 0);
        &::before {
          content: 'ticker: ';
          font-weight: 400;
          //color: #ccc;
        }
      }
      & > .performance {
        position: relative;
        text-align: right;
        padding-right: 2rem;
        color: white;
        font-weight: 700;
        transform: translate3d(3.75rem, 1px, 0);
        &::before {
          content: 'performance: ';
          font-weight: 400;
          //color: #ccc;
        }
        & > .arrow {
          position: absolute;
          top: -0.7rem;
          right: -0.5rem;
          transform-origin: center;
          transform: rotate(90deg);
          color: white;
          &.good {
            transform: rotate(-90deg);
          }
          text-align: center;
          font-size: 2rem;
          padding: 0.25rem;
          &::after {
            content: '\00a0';
            position: absolute;
            top: 25%;
            left: 0;
            bottom: 20%;
            right: 0;
            border: 2px solid white;
            border-radius: 0.25rem;
            z-index: -1;
            background-color: orange;
          }
          &:not(.very) {
            & > .bar {
              background-color: orange;
            }
          }
          & > .bar {
            position: absolute;
            top: 30%;
            left: 23%;
            width: 17%;
            bottom: 30%;
          }
        }
      }
    }
    & > .themes {
      margin-top: 1.5rem;
    }
    & > .charts {
      & > .chart {
        position: absolute;
        top: 13.5rem;
        left: 2rem;
        font-family: Assistant, Roboto, sans-serif;
        width: 50%;
        margin-right: 5rem;
        > .bar {
          cursor: pointer;
          position: relative;
          font-size: 0.8rem;
          height: 0.25rem;
          background-color: #ccc;
          margin-bottom: 0.9rem;
          transition: transform 250ms ease-in-out;
          transform-origin: center;
          &.selected {
            background-color: orange;
            font-weight: 700;
            font-size: 1.2rem;
          }
          &:hover {
            //transform: scale(1.1);
            & > .title {
              color: black;
            }
          }
          & > .title {
            position: absolute;
            left: 100%;
            top: 0;
            transform: translate3d(0.5rem, -50%, 0);
            white-space: nowrap;
          }
          & > .toggle-robo {
            top: 0;
            left: 0;
            transform: translate3d(-1.5rem, -50%, 0) scale(0.75);
            transform-origin: left center;
            width: 1.25rem;
            height: 1.25rem;
            z-index: 4;
            background-color: $brn;
            border-radius: 0.25rem;
            overflow: hidden;
            opacity: 0.25;
            transition: opacity 250ms ease-in-out;
            &:hover,
            &.on {
              opacity: 1;
            }
            .eyes {
              position: absolute;
              top: 0.25rem;
              left: 0;
              right: 0;
              display: flex;
              justify-content: space-evenly;
              .eye {
                width: 0.25rem;
                height: 0.25rem;
                background-color: white;
                border: 1px solid #282828;
                border-radius: 50%;
                & + .eye {
                  background-color: orange;
                }
              }
            }
            > .bars {
              position: absolute;
              width: 50%;
              left: 50%;
              > .bar {
                padding-top: 0;
                height: 1px;
                background-color: white;
                margin-top: 1px;
                &.tall {
                  height: 2px;
                }
                &.gap {
                  margin-bottom: 2px;
                }
              }
            }
          }
        }
      }
      & > .ariel-view {
        $cellWidth: 1.75rem;
        $cellPerfWidth: $cellWidth * 4;
        position: absolute;
        top: 14.75rem;
        bottom: 0.25rem;
        transform: translate3d(0, -5rem, 0);
        //overflow-y: auto;
        //overflow-x: visible;
        width: 22%;
        right: 0;
        display: grid;
        grid-template-rows: repeat(300, 1fr);
        $line-height: 0.6rem;
        &::before {
          position: fixed;
          top: -1.5rem;
          left: -5.5rem;
          content: 'performance';
          font-size: 0.8rem;
        }
        &::after {
          position: fixed;
          top: 7.5rem;
          left: -9.5rem;
          content: 'importance';
          font-size: 0.8rem;
          transform: rotate(-90deg);
        }
        .labels {
          position: absolute;
          top: 0;
          right: 0.5rem;
          width: $cellPerfWidth;
          display: grid;
          grid-template-columns: repeat(4, $cellWidth);
          .label {
            cursor: pointer;
            position: relative;
            //&:hover,
            &.on {
              color: black;
            }
            &::after {
              content: attr(rating);
              position: absolute;
              top: -1.7rem;
              left: 50%;
              transform: translate3d(-50%, 0, 0) rotate(45deg);
              font-size: 0.6rem;
              white-space: nowrap;
            }
          }
        }
        .lines {
          //overflow-y: auto;
          position: absolute;
          top: -2.5rem;
          right: -4.5rem;
          bottom: 0;
          width: 25%;
          box-sizing: border-box;
          padding-top: 2.5rem;
          .pager {
            position: absolute;
            top: 100%;
            right: 3.25rem;
            margin-top: 4.4rem;
            display: grid;
            grid-template-columns: repeat(2, 3rem);
            .previous,
            .next {
              cursor: pointer;
              font-size: 0.6rem;
              text-transform: uppercase;
            }
          }
        }
        .line {
          cursor: pointer;
          position: relative;
          left: -5rem;
          height: $line-height;
          margin-bottom: 1.75px;
          //&:first-of-type {
          //  .performance {
          //    .cell {
          //      &::after {
          //        content: attr(rating);
          //        position: absolute;
          //        top: -1.7rem;
          //        left: 50%;
          //        transform: translate3d(-50%, 0, 0) rotate(45deg);
          //        font-size: 0.6rem;
          //        white-space: nowrap;
          //      }
          //    }
          //  }
          //  //transform: translate3d(2rem, 0, 0);
          //}
          &.on {
            & > .bar {
              background-color: $brn;
            }
          }
          .performance {
            position: absolute;
            top: 0;
            //left: -$cellPerfWidth;
            right: 0;
            width: $cellPerfWidth;
            box-sizing: border-box;
            //padding-right: $line-height * 2;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            //grid-column-gap: 1px;
            .cell {
              position: relative;
              top: $line-height / 3.5;
              background-color: #eee;
              height: $line-height / 5;
              &.on {
                top: 0;
                border-top: none;
                border-radius: 2px;
                background-color: orange;
                height: $line-height * 0.8;
                //transform: translate3d(0, $line-height / 2, 0);
              }
            }
          }
          > .bar {
            position: absolute;
            right: $cellPerfWidth + 6rem;
            top: $line-height * 0.1;
            height: $line-height * 0.8;
            background-color: #dadada;
            border-top-left-radius: $line-height / 2;
            border-bottom-left-radius: $line-height / 2;
            &::after {
              content: attr(title);
              position: absolute;
              top: -0.175rem;
              right: -6.1rem;
              width: 6rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 0.7rem;
              color: $brn;
            }
            .label {
              display: none;
              position: absolute;
              top: 0;
              left: 5rem;
              white-space: nowrap;
            }
            .performance {
              position: absolute;
              top: 0;
              $cellWidth: 0.5rem;
              $cellPerfWidth: $cellWidth * 4;
              left: -$cellPerfWidth;
              width: $cellPerfWidth;
              box-sizing: border-box;
              padding-right: $line-height * 2;
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              //grid-column-gap: 1px;
              .cell {
                position: relative;
                top: $line-height / 3.5;
                background-color: #eee;
                height: $line-height / 4;
                &.on {
                  top: 0;
                  border-top: none;
                  border-radius: 2px;
                  background-color: orange;
                  height: $line-height;
                  //transform: translate3d(0, $line-height / 2, 0);
                }
              }
            }
          }
        }
      }
      & > .scatter {
        position: absolute;
        left: 0.5rem;
        top: 13.5rem;
        width: 8rem;
        height: 13.5rem;
        //background-color: orange;
        box-sizing: border-box;
        border-radius: 0.5rem;
        //border: 2px solid #eee;
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-row-gap: 0.125rem;
        & > .legends {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1;
          pointer-events: none;
          transition: opacity 250ms ease-in-out;
          & > .legend {
            position: absolute;
            white-space: nowrap;
            padding: 0.25rem 0.75rem;
            background-color: white;
            border: 1px solid $brn;
            border-radius: 0.25rem;
            box-shadow: 1px 1px 2px rgba($brn, 0.5);
            will-change: transform;
            &.performance {
              top: -0.5rem;
              left: 0;
              //transform: translate3d(0, -200%, 0);
            }
            &.importance {
              top: 0;
              left: 100%;
              //transform: translate3d(-100%, 0, 0);
            }
            span.label {
              color: #bbb;
            }
          }
        }
        & > .matrix {
          display: grid;
          grid-template-columns: repeat(4, 1.75rem);
          //grid-template-columns: repeat(4, 0.75rem);
          grid-template-rows: repeat(4, 1.37rem);
          grid-gap: 0.25rem;
          &:first-of-type {
            & > :first-of-type {
              //background: $brn;
              border-top-left-radius: 0.5rem;
            }
            & > :nth-of-type(4) {
              //background: $brn;
              border-top-right-radius: 0.5rem;
            }
            .area > .fill {
              bottom: 0;
            }
          }
          &:last-of-type {
            & > :last-of-type {
              //background: $brn;
              border-bottom-right-radius: 0.5rem;
            }
            & > :nth-of-type(13) {
              //background: $brn;
              border-bottom-left-radius: 0.5rem;
            }
            .area > .fill {
              top: 0;
            }
          }
          & > .cell {
            position: relative;
            //background: $brn;
            box-sizing: border-box;
            border: 1px solid #ccc;
            padding: 0.25rem;
            padding-top: 0.25rem;
            padding-left: 0.3rem;
            padding-left: 0.3rem;
            //grid-gap: 1px;
            //overflow: hidden;
            background-color: #e5e5e5;
            &:first-of-type,
            &:nth-of-type(2),
            &:nth-of-type(3),
            &:nth-of-type(4) {
              border-top-color: transparent;
            }
            &:first-of-type,
            &:nth-of-type(5),
            &:nth-of-type(9),
            &:nth-of-type(13) {
              border-left-color: transparent;
            }
            &:nth-of-type(4),
            &:nth-of-type(8),
            &:nth-of-type(12),
            &:nth-of-type(16) {
              border-right-color: transparent;
            }
            &:nth-of-type(13),
            &:nth-of-type(14),
            &:nth-of-type(15),
            &:nth-of-type(16) {
              border-bottom-color: transparent;
            }
            .area {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              .fill {
                max-height: 100%;
                background-color: $brn;
                position: absolute;
                left: 0;
                right: 0;
                height: 50%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
